var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { deleteFile, uploadFile } from '../api';
import { useStudyContext } from '../context';
const MAX_FILE_SIZE_MB = 200;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const isFileValid = (file) => {
    return file.size > MAX_FILE_SIZE_BYTES ? false : true;
};
export const useFileUpload = () => {
    const [files, setFiles] = useState([]);
    const { updateMediaUriPayload } = useStudyContext();
    const handleFileChange = (event) => __awaiter(void 0, void 0, void 0, function* () {
        const selectedFiles = event.target.files;
        if (!selectedFiles || !selectedFiles.length)
            return;
        const newSelectedFiles = Array.from(selectedFiles).filter(selectedFile => isFileValid(selectedFile));
        newSelectedFiles.forEach(selectedFile => {
            setFiles(prevFiles => [
                ...prevFiles,
                {
                    file: selectedFile,
                    progress: 0,
                    status: 'UPLOADING',
                },
            ]);
            startUpload(selectedFile);
        });
    });
    const startUpload = (file) => __awaiter(void 0, void 0, void 0, function* () {
        const interval = setInterval(() => {
            updateFilesStateProgress(file);
        }, 200);
        try {
            const { uri } = yield uploadFile(file);
            updateMediaUriPayload(uri);
            clearInterval(interval);
            finalizeFileUpload(file);
        }
        catch (error) {
            throw new Error(`Error uploading file: ${error}`);
        }
        finally {
            clearInterval(interval);
        }
    });
    const updateFilesStateProgress = (file) => {
        setFiles(prevFiles => {
            const updatedFilesState = prevFiles.map(prevFile => {
                if (prevFile.file.name !== file.name)
                    return prevFile;
                const updatedProgress = Math.min(prevFile.progress + 10, 95);
                return Object.assign(Object.assign({}, prevFile), { progress: updatedProgress });
            });
            return updatedFilesState;
        });
    };
    const finalizeFileUpload = (file) => {
        setFiles(prevFiles => {
            const updatedFilesState = prevFiles.map(prevFile => {
                if (prevFile.file.name !== file.name)
                    return prevFile;
                return Object.assign(Object.assign({}, prevFile), { progress: 100, status: 'COMPLETED' });
            });
            return updatedFilesState;
        });
    };
    const handleFileRemove = (file) => __awaiter(void 0, void 0, void 0, function* () {
        yield deleteFile(file.name);
        setFiles(prevUploads => prevUploads.filter(upload => upload.file.name !== file.name));
    });
    return {
        files,
        handleFileChange,
        handleFileRemove,
    };
};
